import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Receipt } from "../../domain/models/receipt-model";
import {
  ListReceipts,
  ListReceiptsFilterOptions,
} from "../../domain/usecases/list-receipts";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbListReceipts implements ListReceipts {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async list(
    warehouseId: number,
    filterOptions?: ListReceiptsFilterOptions
  ): Promise<Receipt[]> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: { warehouseId, filterOptions },
    });

    switch (res.statusCode) {
      case HttpStatusCode.noContent:
        return res.body || [];
      case HttpStatusCode.ok:
        return res.body || [];
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
